import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TipsportCompetition, TipsportMatch, TipsportOdds} from '../model/broadcast/tipsport';

@Injectable({
  providedIn: 'root'
})
export class TipsportService {

  constructor(
    private http: HttpClient,
  ) {
  }

  // All three go through the same-origin Express proxy (server/proxy-tipsport.js)
  // because Tipsport sends no CORS headers.
  getCompetitions(): Observable<TipsportCompetition[]> {
    return this.http.get<TipsportCompetition[]>('/proxy/tipsport/competitions');
  }

  getMatches(competitionId: string | number): Observable<TipsportMatch[]> {
    return this.http.get<TipsportMatch[]>(`/proxy/tipsport/matches?competition=${competitionId}`);
  }

  // One-shot odds fetch. The proxy hits Tipsport's save endpoint, whose response
  // is self-contained for the requested match, so no server-side polling/caching
  // is needed — the banner component just calls this on a timer while visible.
  getOdds(matchId: string): Observable<TipsportOdds> {
    return this.http.get<TipsportOdds>(`/proxy/tipsport/odds?match=${matchId}`);
  }
}
